<div>
  <ng-container *ngFor="let userLink of socialLinks; let i = index">
    <a style="border-radius: 1rem;"
      [href]="userLink.url"
    >
      <img class="icon" height="26px" width="26px"  [src]="'assets/icons/social-icons/' + userLink.type.toLowerCase() + '.png'">
    </a>
  </ng-container>
</div>
